import { render, staticRenderFns } from "./detalleImportacion.vue?vue&type=template&id=dd8acf66&"
import script from "./detalleImportacion.vue?vue&type=script&lang=js&"
export * from "./detalleImportacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports